var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35938 7.64648C8.58789 7.90039 8.58789 8.28125 8.35938 8.50977C8.10547 8.76367 7.72461 8.76367 7.49609 8.50977L4.5 5.48828L1.47852 8.50977C1.22461 8.76367 0.84375 8.76367 0.615234 8.50977C0.361328 8.28125 0.361328 7.90039 0.615234 7.64648L3.63672 4.625L0.615234 1.60352C0.361328 1.34961 0.361328 0.96875 0.615234 0.740234C0.84375 0.486328 1.22461 0.486328 1.45312 0.740234L4.5 3.78711L7.52148 0.765625C7.75 0.511719 8.13086 0.511719 8.35938 0.765625C8.61328 0.994141 8.61328 1.375 8.35938 1.62891L5.33789 4.625L8.35938 7.64648Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.d0c9672f557922d6d870c4a820c1073d.svg";
export { ForwardRef as ReactComponent };